import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    refresh: false
}

export const departmentSlice = createSlice({
    name: 'department/departmentSlice',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            return { ...state, ...action.payload };
        }
    }
})

export const { setRefresh } = departmentSlice.actions;
export default departmentSlice.reducer